import { horizontalAlignment, verticalAlignment } from '../services/layout-service';
import { noAuthGet } from '../utils/common';

export const adFormatPlaceholder = '__AD_FORMAT__';

export const sampleHlsStream = 'https://tl-open-content-staging.s3.amazonaws.com/live-one-hour/stream.m3u8';

export const defaultConfiguration = {
  name: '',
  accountId: '',
  adTagIds: [],
  adTags: [],
  sourceUrl: '',
  created: 0,
  updated: 0,
  vmapUrlTemplate: '',
};

export const serviceViews = {
  dashbaord: 'dashboard',
  composer: 'composer',
  studio: 'studio',
};

export const serviceViewLabels = {
  dashbaord: 'Dashboard',
  composer: 'Stream Composer',
  studio: 'Creative Studio',
};

export const adTagAssetTypes = {
  video: 'video',
  skin: 'skin',
};

export const adTagAssetTypeDescription = {
  video: 'Video',
  skin: 'Background',
};

export const getSelectedAccount = (state) => {
  return state.selectedAccount || state.account;
};

export const getVastMediaUrl = async (url) => {
  return noAuthGet(url)
    .then((res) => {
      if (!res.data) {
        return null;
      }
      const parser = new DOMParser();
      const doc = parser.parseFromString(res.data, 'application/xml');

      // VAST > Ad > InLine > Creatives > Creative > Linear > MediaFiles > MediaFile
      const creative = doc.querySelector('Creative');
      if (!creative) {
        return null;
      }
      const mediaFile = creative.querySelector('MediaFile');
      if (!mediaFile) {
        return null;
      }
      const mediaUrl = mediaFile.innerHTML.replace('<![CDATA[', '').replace(']]>', '');
      return mediaUrl;
    })
    .catch((err) => {
      console.log('getVastMediaUrl error', err);
      return null;
    });
};

export const formatDuration = (dur) => {
  let minutes = 0;
  if (dur > 59) {
    minutes = Math.floor(dur / 60);
  }
  const seconds = dur - minutes * 60;
  return `${Math.round(minutes).toString().padStart(2, '0')}:${Math.round(seconds).toString().padStart(2, '0')}`;
};

export const defaultAdTag = (format, background, video, adTag) => {
  let creativeScalePercent = 60;
  let contentScalePercent = 40;
  let creativeMarginTopPercent = 0;
  let creativeMarginRightPercent = 0;
  let creativeMarginBottomPercent = 0;
  let creativeMarginLeftPercent = 0;
  let contentMarginTopPercent = 0;
  let contentMarginRightPercent = 0;
  let contentMarginBottomPercent = 0;
  let contentMarginLeftPercent = 0;
  let contentHorizontalAlignment = horizontalAlignment.left;
  const contentVerticalAlignment = verticalAlignment.top;
  const creativeHorizontalAlignment = horizontalAlignment.right;
  const creativeVerticalAlignment = verticalAlignment.top;

  switch (format) {
    case 'pip':
      creativeMarginTopPercent = 13.5;
      creativeMarginRightPercent = 2.3;
      creativeMarginBottomPercent = 0;
      creativeMarginLeftPercent = 1.15;
      contentMarginTopPercent = 25.5;
      contentMarginRightPercent = 1.15;
      contentMarginBottomPercent = 0;
      contentMarginLeftPercent = 2.3;
      break;

    case 'squeezeBack':
      contentScalePercent = 80;
      creativeScalePercent = 0;

      creativeMarginTopPercent = 0;
      creativeMarginRightPercent = 0;
      creativeMarginBottomPercent = 0;
      creativeMarginLeftPercent = 0;
      contentMarginTopPercent = 0;
      contentMarginRightPercent = 0;
      contentMarginBottomPercent = 0;
      contentMarginLeftPercent = 0;

      contentHorizontalAlignment = horizontalAlignment.right;
      break;

    case 'overlay':
      contentScalePercent = 100;
      creativeScalePercent = 0;

      creativeMarginTopPercent = 0;
      creativeMarginRightPercent = 0;
      creativeMarginBottomPercent = 0;
      creativeMarginLeftPercent = 0;
      contentMarginTopPercent = 0;
      contentMarginRightPercent = 0;
      contentMarginBottomPercent = 0;
      contentMarginLeftPercent = 0;
      break;

    default:
      contentScalePercent = 0;
      creativeScalePercent = 100;

      creativeMarginTopPercent = 0;
      creativeMarginRightPercent = 0;
      creativeMarginBottomPercent = 0;
      creativeMarginLeftPercent = 0;
      contentMarginTopPercent = 0;
      contentMarginRightPercent = 0;
      contentMarginBottomPercent = 0;
      contentMarginLeftPercent = 0;
      break;
  }
  let skin_id;
  let skin_url;
  if (background) {
    ({ _id: skin_id, url: skin_url } = background);
  }
  let video_id;
  let video_url;
  if (video) {
    ({ _id: video_id, url: video_url } = video);
  }
  return {
    bg_color: '000000',
    border_color: 'ffffff',
    ad_server: 'External',
    rotating: true,
    ...adTag,
    format,
    skin_id,
    skin_url,
    video_id,
    video_url,
    layout: {
      formatName: format,
      creativeScalePercent,
      contentScalePercent,
      creativeMarginTopPercent,
      creativeMarginRightPercent,
      creativeMarginBottomPercent,
      creativeMarginLeftPercent,
      contentMarginTopPercent,
      contentMarginRightPercent,
      contentMarginBottomPercent,
      contentMarginLeftPercent,
      contentVerticalAlignment,
      contentHorizontalAlignment,
      creativeHorizontalAlignment,
      creativeVerticalAlignment,
      logoHorizontalAlignment: horizontalAlignment.left,
      logoMarginPercent: 0,
      logoWidth: 0,
      logoHeight: 0,
    },
  };
};
